import { render } from "./orderCommentInfoModal.vue?vue&type=template&id=87743954&scoped=true"
import script from "./orderCommentInfoModal.vue?vue&type=script&lang=js"
export * from "./orderCommentInfoModal.vue?vue&type=script&lang=js"

import "./orderCommentInfoModal.vue?vue&type=style&index=0&id=87743954&lang=scss&scoped=true"

import exportComponent from "D:\\由创科技-ljx\\apicode\\github\\DY.Web\\TikTokWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87743954"]])

export default __exports__